<template>
    <footer>

  <!-- Footer Menu-->
    <div id="footer-menu" class="footer-menu-5-icons footer-menu-style-1">
        <a href="/Dashboard" class="active-nav4">
            <i data-feather="home" data-feather-line="1" data-feather-size="21" data-feather-color="red2-dark" data-feather-bg="red2-fade-dark"></i>
            <span>Inicio</span>
        </a>        
        <a href="/OTAgenda">
            <i data-feather="calendar" data-feather-line="1" data-feather-size="21" data-feather-color="magenta1-dark" data-feather-bg="magenta1-fade-light"></i>
            <span>OT Agenda</span>
        </a>

        <a href="/NewOT"><i class="fa fa-plus" style="font-size:2em"></i><span>Nueva OT</span></a>

        <a href="/MisOT">
            <i data-feather="briefcase" data-feather-line="1" data-feather-size="21" data-feather-color="orange-dark" data-feather-bg="orange-fade-light"></i>
            <span>Mis OTs</span>
        </a>       
        <a href="/login">
            <i data-feather="log-out" data-feather-line="1" data-feather-size="21" data-feather-color="dark2-dark" data-feather-bg="dark2-fade-dark"></i>
            <span>Salir</span>
        </a>       
        <div class="clear"></div>
    </div>

    </footer>
</template>


<script>

export default {

methods: {
      logout: function () {
        this.$store.dispatch('logout')
        .then(() => {
            window.location='/';
          //this.$router.push('/login')
        })
      }
    }

}

</script>
